"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schoolSchema = void 0;
const zod_1 = require("zod");
// Схема для School
exports.schoolSchema = zod_1.z.object({
  id: zod_1.z.string(),
  name: zod_1.z.string().optional(),
  description: zod_1.z.string().optional(),
  owner_id: zod_1.z.string().optional(),
  logo: zod_1.z.string().optional(),
  cover: zod_1.z.string().optional(),
  subject_id: zod_1.z.number().optional(),
  language_id: zod_1.z.number().optional(),
  status: zod_1.z.string().optional(),
  teachers_count: zod_1.z.number().optional(),
  students_count: zod_1.z.number().optional(),
  classrooms_count: zod_1.z.number().optional(),
  created_at: zod_1.z.string().optional(),
  updated_at: zod_1.z.string().optional()
})
// TODO: remove catchall, need to define all fields
.catchall(zod_1.z.any()); // для других полей
